<section class="flex items-center gap-2.5">
    <div class="flex-1 text-sm font-semibold text-primaryPink">
        {{ data.message }}
    </div>
    <img
        (click)="snackBarRef.dismissWithAction()"
        alt="close icon"
        height="21"
        ngSrc="/assets/icons/warning-x-close-icon.svg"
        width="20" />
</section>
